import classnames from 'classnames';
import React from 'react';
import { compose, defaultProps, withPropsOnChange } from 'recompose';
import uuid from 'uuid';
import { getConfigByDirection } from '../../../helpers/components/chart-grid';
import styles from '../../../styles/components/chart-grid.module.scss';

const GridLines = React.memo(({ children }) => (
  <svg className={styles.lines} viewBox='0 0 100 100' preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg'>
    {children}
  </svg>
));

const GridLine = props => <line key={uuid('grid-chart-line')} className={styles.line} {...props} />;

const GridMarks = React.memo(({ className, children }) => (
  <aside className={className}>
    <div className={styles.marks}>{children}</div>
  </aside>
));

const GridMark = React.memo(({ mark, ...style }) => (
  <div className={styles.mark} style={style}>
    <span className={styles.value}>{mark}</span>
  </div>
));

const ChartGridComponent = React.memo(({ lines, marks, direction, className, reverse, children }) => (
  <article className={classnames(className, styles.container, styles[direction], { [styles.reverse]: reverse })}>
    <div className={styles.wrapper}>
      {direction === 'horizontal' && (
        <GridMarks className={styles.left}>
          {marks.map(mark => (
            <GridMark key={uuid('grid-chart-mark')} {...mark} />
          ))}
        </GridMarks>
      )}
      <section className={styles.center}>
        <GridLines>
          {lines.map(line => (
            <GridLine key={uuid('grid-chart-line')} {...line} />
          ))}
        </GridLines>
        {children}
      </section>
      {direction === 'vertical' && (
        <GridMarks className={styles.bottom}>
          {marks.map(mark => (
            <GridMark key={uuid('grid-chart-mark')} {...mark} />
          ))}
        </GridMarks>
      )}
    </div>
  </article>
));

export const ChartGrid = compose(
  defaultProps({ direction: 'vertical' }),
  withPropsOnChange(['direction', 'marks'], ({ direction, marks }) => getConfigByDirection(direction)(marks))
)(ChartGridComponent);
